import { useEffect, useState } from "react";
import { leerUltimoPedidoCliente } from "../utils/ultimoPedidoCliente";

function useUltimoPedidoCliente() {
  const [ultimoPedido, setUltimoPedido] = useState(leerUltimoPedidoCliente);

  useEffect(() => {
    const actualizarUltimoPedido = () => {
      setUltimoPedido(leerUltimoPedidoCliente());
    };

    window.addEventListener("storage", actualizarUltimoPedido);

    return () => {
      window.removeEventListener("storage", actualizarUltimoPedido);
    };
  }, []);

  return {
    ultimoPedidoFecha: ultimoPedido.fecha,
    ultimoPedidoIds: ultimoPedido.productosIds,
  };
}

export default useUltimoPedidoCliente;
